// extracted by mini-css-extract-plugin
export var label = "_ei-5";
export var slideContainer = "_ei-0";
export var slider = "_ei-1";
export var sliderLg = "_ei-4";
export var sliderMd = "_ei-3";
export var sliderSm = "_ei-2";